import React from 'react'
import { Stack, Text, Box } from '@chakra-ui/react'
import { Address } from '@Types'
import { MemoLabels } from '../CheckMemosForm'

interface CheckRecipientSectionProps {
  deliveryMethod: string
  sendTo: string
  recipientName: string
  recipientAddress: Address
  memo1?: string
  memo2?: string
  memo3?: string
}

const CheckRecipientSection = ({
  deliveryMethod,
  sendTo,
  recipientName,
  recipientAddress,
  memo1,
  memo2,
  memo3
}: CheckRecipientSectionProps) => {
  return (
    <Stack spacing={2}>
      <Text as='h3' textStyle='h3'>
        Recipient Information
      </Text>
      <Stack direction='row' w='100%' spacing={4}>
        <Box w='50%'>
          <Stack spacing={2}>
            <Box>
              <Text fontWeight='bold'>Delivery Method</Text>
              <Text>{deliveryMethod}</Text>
            </Box>
            <Box>
              <Text fontWeight='bold'>Send To</Text>
              <Text>{sendTo}</Text>
            </Box>
            <Box>
              <Text>{recipientName}</Text>
              <Text>{recipientAddress.address}</Text>
              {recipientAddress.addressLine2 && <Text>{recipientAddress.addressLine2}</Text>}
              <Box>
                {recipientAddress.city}
                {recipientAddress.stateProvince || recipientAddress.postalCode ? `, ` : ''}{' '}
                {recipientAddress.stateProvince} {recipientAddress.postalCode}
                {recipientAddress.country && <Text>{recipientAddress.country}</Text>}
              </Box>
            </Box>
          </Stack>
        </Box>
        <Box w='50%'>
          <Stack spacing={2}>
            {memo1 && (
              <Box>
                <Text fontWeight='bold'>{MemoLabels.memo1}</Text>
                <Text>{memo1}</Text>
              </Box>
            )}
            {memo2 && (
              <Box>
                <Text fontWeight='bold'>{MemoLabels.memo2}</Text>
                <Text>{memo2}</Text>
              </Box>
            )}
            {memo3 && (
              <Box>
                <Text fontWeight='bold'>{MemoLabels.memo3}</Text>
                <Text>{memo3}</Text>
              </Box>
            )}
          </Stack>
        </Box>
      </Stack>
    </Stack>
  )
}

export default CheckRecipientSection
